import { Injectable } from '@angular/core';
import { TradeInstructionsComponent } from '@irb/irb-editors/edit-trading-instructions/trade-instructions/trade-instructions.component';
import { orderTypes } from '../trade-instructions.model';
@Injectable({
	providedIn: 'root',
  })
export class AlgorithmLayoutSetup {
	algorithmLayoutSetup(parent:TradeInstructionsComponent, readOnly?:any, item?:any) {
	const self = parent;
    let destination = '';
    let algorithm = '';
    if (item) {
      destination = item.notHeldDestination;
      algorithm = item.notHeldAlgorithm;
    } else {
      if (self.notHeldDestinationSelected) {
        destination = self.notHeldDestinationSelected.id;
      }
      if (self.algorithmSelected) {
        algorithm = self.algorithmSelected.value;
      }
    }

    if (readOnly) {
      //dijit.byId("notHeldAlgorithm").set("value", algorithm);  // todo: finish
      //dijit.byId("notHeldDestination").set("value", destination); // todo: finish
    } else {
      //resetFormFields("algorithmDepFieldsLay");  // todo: finish
    }
    self.layoutFieldsShowHide.iWPriceLayDisplay = false;
    // todo: finish
    // //IREBALUX-1338 - Trailing Stop Orders - In-Line Edit - Add Trailing Stop Order Type to Trade Instructions Modal
    
    if(self.notHeldDestinationSelected && self.notHeldDestinationSelected.id ===  "AOM_PRINTER"){
      self.orderTypes = self.getFilteredArray(orderTypes, 'orderType', 'ORDERTYPEONLY' );
    }else{
      self.orderTypes = self.getFilteredArray(orderTypes, 'trailingStopAvailable', 'TRUE');
    }
    
    // dijit.byId('orderType').query = (dijit.byId("notHeldDestination").getValue() == "AOM_PRINTER") ? {
    //     'destType': '*ORDERTYPEONLY*"'
    //   }
    //   : {
    //     display: true
    //   }; //IREBALUX-1507 - Prevent Limit Orders when Destination is Set to Block Desk
    self.ordNotHeldMaxVolPctRequired = true;

    //defaults
    self.layoutFieldsShowHide.fillReportingLay = false;
    self.layoutFieldsShowHide.startTimeLay = false;
    self.layoutFieldsShowHide.endTimeLay = false;
    self.layoutFieldsShowHide.participationLay = false;
    self.layoutFieldsShowHide.incExclLay = false;
    self.layoutFieldsShowHide.maxVolumeLay = false;
    self.layoutFieldsShowHide.displaySizeLay = false;
    self.layoutFieldsShowHide.styleLay = false;
    self.layoutFieldsShowHide.algorithmDepFieldsLayDisplay = false;
    self.layoutFieldsShowHide.auctionOnlyLay = false;

    if (destination === "CITADEL" && algorithm === "VWAP") {
      self.layoutFieldsShowHide.fillReportingLay = true;
      self.layoutFieldsShowHide.startTimeLay = true;
      self.layoutFieldsShowHide.endTimeLay = true;
      self.layoutFieldsShowHide.algorithmDepFieldsLayDisplay = true;
    } else if (destination == "CITADEL" && algorithm == "TWAP") {
      self.layoutFieldsShowHide.fillReportingLay = true;
      self.layoutFieldsShowHide.startTimeLay = true;
      self.layoutFieldsShowHide.endTimeLay = true;
      self.layoutFieldsShowHide.algorithmDepFieldsLayDisplay = true;
    } else if (destination == "CITADEL" && algorithm == "PERCENTAGE_OF_VOLUME") {
      if (readOnly === null) {
        //TODO: check with legacy
       // self.ordNotHeldInclude.nativeElement.set("value", "Include"); 
      }

      self.layoutFieldsShowHide.fillReportingLay = true;
      self.layoutFieldsShowHide.startTimeLay = true;
      self.layoutFieldsShowHide.endTimeLay = true;
      self.layoutFieldsShowHide.participationLay = true;
      self.layoutFieldsShowHide.incExclLay = true;
      self.layoutFieldsShowHide.algorithmDepFieldsLayDisplay = true;

      if (!self.ordNotHeldIncludeExcludeSelected) {
        self.ordNotHeldIncludeExcludeSelected = self.ordNotHeldIncludeExclude[0];
        self.ordNotHeldIncludeExcludeChanged(self.ordNotHeldIncludeExcludeSelected);
      }
    } else if (destination == "VIRTU" && (algorithm == "TWAP" || algorithm == "PERCENTAGE_OF_VOLUME")) {
      self.layoutFieldsShowHide.startTimeLay = true;
      self.layoutFieldsShowHide.endTimeLay = true;
      self.layoutFieldsShowHide.maxVolumeLay = true;
      self.layoutFieldsShowHide.maxVolumeLabel = "Max Volume %";
      self.layoutFieldsShowHide.algorithmDepFieldsLayDisplay = true;
    } else if (destination == "VIRTU" && (algorithm == "VWAP")) {
      self.layoutFieldsShowHide.startTimeLay = true;
      self.layoutFieldsShowHide.endTimeLay = true;
      self.layoutFieldsShowHide.maxVolumeLay = true;
      self.layoutFieldsShowHide.maxVolumeLabel = "Max Volume %";
      self.layoutFieldsShowHide.algorithmDepFieldsLayDisplay = true;
      self.ordNotHeldMaxVolPctRequired = false;
    } else if (destination == "VIRTU" && algorithm == "TARGET_CLOSE") {
      self.layoutFieldsShowHide.startTimeLay = true;
      self.layoutFieldsShowHide.styleLay = true;
      self.layoutFieldsShowHide.algorithmDepFieldsLayDisplay = true;
      self.layoutFieldsShowHide.auctionOnlyLay = true;
    } else if (destination == "VIRTU" && algorithm == "FAN") {
      self.layoutFieldsShowHide.displaySizeLay = true;
      self.layoutFieldsShowHide.styleLay = true;
      self.layoutFieldsShowHide.algorithmDepFieldsLayDisplay = true;
    } else if (destination == "VIRTU" && algorithm == "OASIS") {
      self.layoutFieldsShowHide.startTimeLay = true;
      self.layoutFieldsShowHide.endTimeLay = true;
      self.layoutFieldsShowHide.styleLay = true;
      self.layoutFieldsShowHide.algorithmDepFieldsLayDisplay = true;
    } else if (destination == "VIRTU" && (algorithm === "OPPORTUNISTIC" || algorithm === "CATCH")) {
      self.layoutFieldsShowHide.startTimeLay = true;
      self.layoutFieldsShowHide.endTimeLay = true;
      self.layoutFieldsShowHide.maxVolumeLay = true;
      self.layoutFieldsShowHide.maxVolumeLabel = "Max Volume %";
      self.layoutFieldsShowHide.styleLay = true;
      self.layoutFieldsShowHide.algorithmDepFieldsLayDisplay = true;
    } else if (destination == "VIRTU" && algorithm == "COVERT") {
      //TODO: Compare with legacy
     /* if (!self.pfs.updateOrderPayload.disableMode) {
        self.ordNotHeldStyle.nativeElement.value = "NEUTRAL";
      }*/

      self.layoutFieldsShowHide.styleLay = true;
      self.layoutFieldsShowHide.algorithmDepFieldsLayDisplay = true;
    }

    // todo: finish - done
    // // Order type dropdown field should only have 2 options available: Market or Limit. As part of the MVP,
    // //   we will not allow users to add Stop or Stop Limit order type instructions when editing multiple orders.
    //
    // dijit.byId('orderType').query = {
    //   destType: self.getDestinationQ()
    // }; //IREBALUX-1507 - Prevent Limit Orders when Destination is Set to Block Desk
    self.setDestination();
	}
}
